import type { UnauthenticatedTransferRequest } from '@getstep/sdk/dist/api/generated/TransferProto'
import { fetch } from 'cross-undici-fetch'
import type { JsonValue } from 'type-fest'

import { extendConsole } from '../shared/logging/console'

/** Creates a fetch function. That's it. */
export const makeFetch =
    (baseUrl: string, headers?: HeadersInit) =>
    async <T>(
        url: string,
        init: Omit<RequestInit, 'body'> & { body?: JsonValue } = {
            method: 'GET',
        }
    ): Promise<T> => {
        const location = baseUrl + url
        const logger = extendConsole(`fetch~${location}`)
        logger.debug(init?.method, init?.body)

        const response = await fetch(location, {
            ...init,
            headers: {
                'Content-Type': 'application/json',
                ...headers,
                ...init?.headers,
            },
            body: init?.body ? JSON.stringify(init.body) : undefined,
        })

        logger.debug(response.status, response.statusText)
        const data = await response.json()
        return data
    }

const fetchJSON = makeFetch('/api')

/**
 * Wrappers for local api routes from src/pages/api
 */
export const localApi = {
    // TODO (@cataline): replace this with PublicApi
    async createPaymentIntent(request: UnauthenticatedTransferRequest) {
        const r = await fetchJSON<{ secret: string }>(
            `/transfer/${request.id}/intent`,
            {
                method: 'POST',
            }
        )

        return typeof r?.secret === 'string'
            ? (r as { secret: string })
            : undefined
    },
}
